import { styled } from '@styledComponents';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { TOP_BANNER_HEIGHT } from '@layout';

export const StyledSection = styled(Box)`
  height: 96vh;
  min-height: 730px;
  position: relative;
  z-index: 1;
  contain: strict;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    min-height: 730px;
  }
`;

export const HeroVideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
`;

export const HeroBodymovinWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const HeroVideoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: center center;
  overflow: hidden;
`;

export const HeroOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: #000;
  z-index: 3;
  opacity: 0.25;
`;

export const HeroCloudImage = styled(CloudImage)`
  position: absolute;
  margin-left: 50%;
  transform: translateX(-50%);
`;

export const HeroTextPairing = styled(TextPairing)`
  margin-top: 0px;
  margin-bottom: ${themeSpace(8)};
  .text-pairing-body {
    max-width: 440px;
  }
  .text-pairing-eyebrow {
    width: 310px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 520px;
    }
    .text-pairing-eyebrow {
      width: 100%;
    }
  }
  ${themeMediaQuery('below_sm')} {
    margin-top: calc(${themeSpace(12)} + ${TOP_BANNER_HEIGHT}px);
    margin-bottom: ${themeSpace(5)};
    justify-content: center;
    .text-pairing-body {
      max-width: 90%;
    }
    .text-pairing-title {
      max-width: 90%;
      font-size: 38px;
    }
    .text-pairing-eyebrow {
      width: 90%;
    }
  }
`;

export const RegistryHeroTextColumn = styled(Columns)`
  position: relative;
  height: 100%;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  @media (max-width: 1024px) and (min-width: 768px) {
    margin-top: ${themeSpace(10)};
  }
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(10)};
  }
  ${themeMediaQuery('md')} {
    margin-top: ${themeSpace(8)};
  }
  ${themeMediaQuery('xl')} {
    margin-top: ${themeSpace(8)};
  }
`;

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 380px;
  }
  .text-pairing-body {
    max-width: 430px;
    line-height: 32px;
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 544px;
    }
    .text-pairing-body {
      max-width: 430px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 544px;
    }
    .text-pairing-body {
      max-width: 430px;
    }
  }
`;
